module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', [(_vm.sendStatus == 'Sending') ? _c('div', [_c('h2', [_vm._v("\r\n            " + _vm._s(_vm.$t("invitePreviousSponsorsView.sendingInvitations")) + "\r\n        ")]), _vm._v(" "), _c('KkSpinner')], 1) : (_vm.sendStatus == 'Sent') ? _c('div', [_c('h2', [_vm._v("\r\n            " + _vm._s(_vm.$t("invitePreviousSponsorsView.invitationsSent")) + "\r\n        ")])]) : _c('div', [(_vm.sponsors.length == 0) ? _c('div', {
    staticClass: "section"
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t("invitePreviousSponsorsView.noSponsors")) + "\r\n        ")]) : _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t("invitePreviousSponsorsView.invitingSponsorsTo", [_vm.store.selectedOrganization.name, _vm.store.selectedEvent.name])))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("invitePreviousSponsorsView.chooseSponsors")))]), _vm._v(" "), _c('div', {
    staticClass: "invite-previous-sponsors-button"
  }, [_c('button', {
    staticClass: "button button-green invite-previous-sponsors-button",
    attrs: {
      "disabled": _vm.selectedSponsorIds.length == 0
    },
    on: {
      "click": _vm.sendInvitations
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t("invitePreviousSponsorsView.inviteSelected")) + "\r\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "left-part"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.allSelected
    },
    on: {
      "click": _vm.toggleAll
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-part"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("invitePreviousSponsorsView.selectAll")))])])]), _vm._v(" "), _c('div', {
    staticClass: "previous-sponsor-list"
  }, _vm._l((Object.keys(_vm.sponsorsByOrg)), function(orgId) {
    return _c('div', {
      key: orgId
    }, [_c('div', {
      staticClass: "previous-sponsor-list-organization-title"
    }, [_vm._v("\r\n                        " + _vm._s(_vm.$t("invitePreviousSponsorsView.sponsorsFrom", [_vm.sponsorsByOrg[orgId][0].organizationName])) + "\r\n                    ")]), _vm._v(" "), _vm._l((_vm.sponsorsByOrg[orgId]), function(s) {
      return _c('div', {
        key: s.sponsorId,
        staticClass: "list-item"
      }, [_c('div', {
        staticClass: "left-part"
      }, [(s.sponsor.email) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedSponsorIds),
          expression: "selectedSponsorIds"
        }],
        attrs: {
          "id": s.sponsor.sponsorId,
          "type": "checkbox"
        },
        domProps: {
          "value": s.sponsor.sponsorId,
          "checked": Array.isArray(_vm.selectedSponsorIds) ? _vm._i(_vm.selectedSponsorIds, s.sponsor.sponsorId) > -1 : (_vm.selectedSponsorIds)
        },
        on: {
          "__c": function($event) {
            var $$a = _vm.selectedSponsorIds,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = s.sponsor.sponsorId,
                $$i = _vm._i($$a, $$v);
              if ($$c) {
                $$i < 0 && (_vm.selectedSponsorIds = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.selectedSponsorIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.selectedSponsorIds = $$c
            }
          }
        }
      }) : _vm._e(), _vm._v(" "), (!s.sponsor.email) ? _c('span', {
        staticClass: "icon icon-question",
        on: {
          "click": function($event) {
            _vm.infoPopup()
          }
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "right-part"
      }, [(s.sponsor.sponsorType === 'Private') ? _c('div', [_vm._v(_vm._s(s.sponsor.fullName))]) : _c('div', [_vm._v(_vm._s(s.sponsor.companyName))]), _vm._v(" "), (s.sponsor.email && !s.sponsor.editingEmail) ? _c('div', [_vm._v(_vm._s(s.sponsor.email))]) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (s.sponsor.email),
          expression: "s.sponsor.email"
        }],
        attrs: {
          "type": "text",
          "placeholder": _vm.$t('invitePreviousSponsorsView.setEmail')
        },
        domProps: {
          "value": (s.sponsor.email)
        },
        on: {
          "keydown": function($event) {
            _vm.emailInput(s.sponsor, $event)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            s.sponsor.email = $event.target.value
          }
        }
      })])])
    })], 2)
  }))])]), _vm._v(" "), _c('kk-generic-popup', {
    attrs: {
      "title": _vm.$t('invitePreviousSponsorsView.infoPopupTitle'),
      "visible": _vm.popupVisible
    },
    on: {
      "close": function($event) {
        _vm.closePopup()
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("invitePreviousSponsorsView.infoPopupText")))]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goToAddSponsor()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("sponsorsView.addSponsor")) + " "), _c('span', {
    staticClass: "icon-arrow-right2"
  })]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goToContacts()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("invitePreviousSponsorsView.goToContacts")) + " "), _c('span', {
    staticClass: "icon-arrow-right2"
  })])])], 1) : _c('div', [_c('kk-spinner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7138ec60","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/InvitePreviousSponsorsView.vue
// module id = 123
// module chunks = 0